// extracted by mini-css-extract-plugin
export default {"quoterErrorContainer":"_quoter-error_quoterErrorContainer__1XUkL"};